<template>
    <canvas id="glyphs" resize=""></canvas>
</template>

<script>

import glyphs from '@/doodles/glyphs'

window.onload = function() {
  let canvas = document.getElementById('glyphs')

  glyphs(canvas)
}

export default {
  name: 'glyphs',
  created() {
  }
}

</script>

<style scoped>
#glyphs {
  width: 100%;
  height: 500px;
  margin: 0 auto;
  /*background: #140000;*/
  /*border:1px solid #000;*/
  display: block;
  cursor: pointer;
}
</style>
